import { createAsyncThunk } from "@reduxjs/toolkit";
import { PropertyCategory } from "../../../client/services";
import { toastHandler } from "../../../utils/toastHandler";
import { FindPropertyCategory, GetPropertyCategory } from "../../propertyCategory/api/interface";

export const findSelectPropertyCategory = createAsyncThunk(
  "selectPropertyCategory/findSelectPropertyCategory",
  async (values: FindPropertyCategory, { rejectWithValue }) => {
    try {
      const response = await PropertyCategory.find({
        query: values,
      });
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const searchSelectPropertyCategory = createAsyncThunk(
  "selectPropertyCategory/searchSelectPropertyCategory",
  async (values: FindPropertyCategory, { rejectWithValue }) => {
    try {
      const response = await PropertyCategory.find({
        query: values,
      });
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);


export const getSelectPropertyCategory = createAsyncThunk(
  'selectPropertyCategory/getSelectPropertyCategory',
  async ({ id }: GetPropertyCategory, { rejectWithValue }) => {
    try {
      const response = await PropertyCategory.get(id);

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);
